import { Stack, styled } from "@mui/material";

export const StyledGetInspiredCard = styled(Stack)(({ theme }) => ({
    '& .Card': {
        margin: '8px', borderRadius: '10px', width: '25%', height: '345px',
        
        '& p': {
            color: 'white'
        },

        '& .MuiBox-root': {
            padding: '20px 30px 0', textAlign: 'center'
        },

        '& .ImageButton': {
            '& .MuiButtonBase-root': {
                width: '100%'
            }
        },

        [theme.breakpoints.down('md')]:
        {
            marginBottom: '15px',
            width: 'fit-content',
            maxWidth: '400px',
            height: 'unset'
        },
    },
    '& .CoverImage': {
        width: '100%', objectFit: 'cover', borderRadius: '10px 10px 0 0',
        height: '200px',
        [theme.breakpoints.down('md')]:
        {
            marginBottom: '15px',
            width: 'fit-content',
            maxWidth: '400px',
            height: 'unset'
        },
        [theme.breakpoints.down('sm')]:
        {
            width: '100%'
        },
    },
    '& .Icon': {
        maxWidth: '100%', marginBottom: '-20px'
    },
}));

